import { Flex } from "@/common/styles";
import styled from "styled-components";

export const VisitorListContainer = styled.div``;

export const ActionsHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 20px;

  .left {
  }

  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;
